// src/cert/pcidss.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const PCIDSS = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>PCI DSS अनुपालन</h1>
                <p>पेमेंट कार्ड इंडस्ट्री डेटा सिक्युरिटी स्टँडर्ड (Payment Card Industry Data Security Standard)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>PCI DSS म्हणजे काय?</h2>
                    <p>
                        The PCI Security Standards Council is a global forum for the ongoing development, enhancement, storage, dissemination, and implementation of security standards for account data protection. The Standards Council was established by the major credit card associations (Visa, MasterCard, American Express, Discover, JCB) as a separate organization to define appropriate practices that merchants and service providers should follow to protect cardholder data. It is this council of companies that created the Payment Card Industry (PCI) Data Security Standards (DSS).

                        PCI DSS is a set of network security and business best practices guidelines adopted by the PCI Security Standards Council to establish a minimum security standard to protect customers payment card information. The scope of the PCI DSS includes all systems, networks, and applications that process, store, or transmit cardholder data, and also systems that are used to secure and log access to the systems in scope.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>कार्ड डेटा चोरी, फसवणूक आणि हॅकिंग रोखता येतात</li>
                        <li>$100,000+ दंड आणि कार्ड स्वीकारण्याचा अधिकार गमावण्यापासून वाचतो</li>
                        <li>ऑनलाइन पेमेंट, POS, ATM, वॉलेटसाठी आवश्यक</li>
                        <li>एन्क्रिप्शन, फायरवॉल, VAPT, ऑडिट नियमित होतात</li>
                        <li>ग्राहकांचा विश्वास आणि व्यवसाय सातत्य</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>PCI DSS अनुपालनासाठी अर्ज करा</h2>
                    <ApplyForm certification="PCI DSS Compliance" />
                </section>
            </div>
        </div>
    );
};

export default PCIDSS;